export default "__VITE_ASSET__C6VqUPP5__"